import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-duckhunt',
  templateUrl: './duckhunt.component.html',
  styleUrls: ['./duckhunt.component.scss']
})
export class DuckhuntComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
